import { Table, Typography } from "antd";
import { useSelector } from "react-redux";

const { Title } = Typography;

const format = (v) =>
  `₹${Number(v || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
  })}`;

const Section3_1 = ({ printMode = false }) => {
  // ✅ FIX: get correct state
  const { section3_1 = [] } = useSelector((state) => state.gstr3b);

  const defaultRows = [
    {
      key: "a",
      label:
        "(a) Outward taxable supplies (other than zero rated, nil rated and exempted)",
    },
    {
      key: "b",
      label: "(b) Outward taxable supplies (zero rated)",
    },
    {
      key: "c",
      label: "(c) Other outward supplies (Nil rated, exempted)",
    },
    {
      key: "d",
      label: "(d) Inward supplies (liable to reverse charge)",
    },
    {
      key: "e",
      label: "(e) Non-GST outward supplies",
    },
    {
      key: "total",
      label: "Total value",
    },
  ];

  // ✅ SAFE + FAST (O(1) lookup instead of find)
  const backendMap = Object.fromEntries(
    (section3_1 || []).map((item) => [item.key, item])
  );

  const finalData = defaultRows.map((row) => {
    const match = backendMap[row.key] || {};
    return {
      ...row,
      taxable: match.taxable ?? 0,
      igst: match.igst ?? 0,
      cgst: match.cgst ?? 0,
      sgst: match.sgst ?? 0,
      cess: match.cess ?? 0,
    };
  });

  const columns = [
    { title: "Nature of Supply", dataIndex: "label" },
    {
      title: "Taxable Value",
      dataIndex: "taxable",
      align: "right",
      render: format,
    },
    {
      title: "Integrated Tax",
      dataIndex: "igst",
      align: "right",
      render: format,
    },
    {
      title: "Central Tax",
      dataIndex: "cgst",
      align: "right",
      render: format,
    },
    {
      title: "State/UT Tax",
      dataIndex: "sgst",
      align: "right",
      render: format,
    },
    {
      title: "CESS Tax",
      dataIndex: "cess",
      align: "right",
      render: format,
    },
  ];

  return (
    <>
      <Title
        level={5}
        style={{
          fontSize: "clamp(14px, 2vw, 18px)",
          lineHeight: 1.4,
          wordBreak: "break-word",
          marginBottom: 12,
        }}
      >
        3.1 Details of Outward Supplies and inward supplies liable to reverse charge
      </Title>

      <Table
        columns={columns}
        dataSource={finalData}
        pagination={false}
        bordered
        rowKey="key"
        scroll={printMode ? undefined : { x: "max-content" }}
      />
    </>
  );
};

export default Section3_1;